export default [
  {elementType: "geometry", stylers: [{color: "#292d31"}]},
  {elementType: "labels.text.stroke", stylers: [{color: "#000000"}]},
  {elementType: "labels.text.fill", stylers: [{color: "#ffffff"}]},
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{visibility: "off"}],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{color: "#161a20"}],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{color: "#212a37"}],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{lightness: -50}]
  },
  {
    featureType: "transit",
    elementType: "labels",
    stylers: [{visibility: "off"}],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{color: "#17263c"}],
  },
]
